export function getUniqElementsFromArrayByName<T extends { name: string | number }>(array: T[]): T[] {
  const names = new Set<string | number>();
  return array.filter((item) => !names.has(item.name) && names.add(item.name));
}
